import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { createRoutes, Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	...createRoutes(
		{
			frame: true,
			restrictedAccess: {
				authOnly: true,
				role: ['staff', 'support'],
			},
			ssr: {
				enabled: false,
				seo: false,
			},
		},
		[
			{
				id: 'admin-organizations-list',
				path: '/admin/organizations',
				component: loadable(async () => import(/* webpackChunkName: "pages/admin-organizations-list" */ './index'), {
					exportName: 'AdminOrganizationsList',
					fallback: Loading,
				}),
			},
		],
	),
];
